import React, { useEffect, useState } from "react";
import axios from "axios";
import "./DetailArtikel.scss";
import { Link, useParams, useHistory } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { config } from "../../config";
import { Spin } from "antd";
import LoadingOverlay from "../../component/LoadingOverlay";
import { useNavigate } from "react-router-dom";

const DetailArtikel = () => {
  const { id } = useParams(); // Extract `id` from the URL
  const [article, setArticle] = useState(null); // State to hold article data
  const [loading, setLoading] = useState(true); // State to manage loading state
  const [error, setError] = useState(null); // State to manage errors
  const history = useHistory();

  const handleClick = (e) => {
    e.preventDefault();
    history.push("/");

    // Tunggu beberapa saat sampai halaman utama muncul
    setTimeout(() => {
      const element = document.getElementById("article");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100); // Delay kecil agar DOM sempat render
  };

  // Fetch article data from the API
  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const response = await axios.get(
          `${config.BASE_URL}berita/webFindOne/${id}`
        );
        setArticle(response.data.data); // Populate article state with API response

        setLoading(false);
      } catch (err) {
        console.error("Error fetching article:", err);
        setError("Failed to load article.");
        setLoading(false);
      }
    };

    fetchArticle();
  }, [id]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <LoadingOverlay />
        <p style={{ color: "#F1582E", marginTop: "10px", fontWeight: "bold" }}>
          Harap Tunggu Sesaat..
        </p>
      </div>
    );
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <section id="DetailArtikel">
      <div className="navbar">
        <a href="#" onClick={handleClick} className="link-back">
          <FeatherIcon icon="arrow-left" />
          Kembali
        </a>
      </div>
      <div className="container">
        <div className="news-content">
          <h2>{article.judul}</h2>
          <p className="news-date">
            {new Date(article.tanggalRelease).toLocaleString()}
          </p>
          <img
            src={
              article.foto
                ? `${
                    config.BASE_URL
                  }getReferenceFile?pathFile=${encodeURIComponent(
                    article.foto
                  )}`
                : "default-image-path.png"
            }
            alt="News"
          />
          <p
            dangerouslySetInnerHTML={{
              __html: article.isi,
            }}
          />
          {article.createdName && (
            <p className="created-by">
              Dibuat oleh: <strong>{article.createdName}</strong>
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default DetailArtikel;
